<template>
  <base-dialog v-bind="$attrs" @handleClose="handleClose" @handleConfirm="handleConfirm"
               :show-close="false">
    <template #title>{{$t('common.createDomainGroup') }}</template>
    <el-form ref="createAddDomainForm" :model="form" :rules="rules" label-width="100px"
             class="demo-ruleForm">
      <el-form-item :label="$t('newProjectV2.name')" prop="domain">
        <el-input v-model="form.domain"></el-input>
      </el-form-item>
    </el-form>
    <template #confirm>{{$t('project.create')}}</template>
  </base-dialog>
</template>

<script>
import { addCustomDomain } from '@/services/commonApi';
export default {
  name: 'createCustomDomain',
  data () {
    return {
      form: {
        domain: ''
      },
      rules: {
        domain: [
          { required: true, message: this.$t('memory.domainNotEmpty'), trigger: 'blur' },
          { min: 1, max: 16, message: this.$t('common.customDomainLength'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
      this.$refs.createAddDomainForm.resetFields();
    },
    handleConfirm () {
      this.$refs.createAddDomainForm.validate(async (valid) => {
        if (!valid) return;
        const { success } = await addCustomDomain(this.form)
        if (success) {
          this.$emit('handleConfirm', { ...this.form });
          this.$refs.createAddDomainForm.resetFields();
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  height: auto;
  padding: 0 40px 0 0;
}
</style>